import { defaultValues } from "./Component";
export default defaultValues;
